import React, { useEffect, useState } from "react";

import CompellonApi from "apis/compellon";
import { Modal, PageLoader } from "clearsense-ui/components";

import Details from "./Details";

import { TARGET_RATES, tempAdjustment } from "../constants";
import { getAdjustments } from "../Utils/apiDataConverters";
import { roundNumbers } from "../Utils/extract";

const View = ({
  selectedWhatIf,
  isWhatIfModalOpen,
  setIsWhatIfModalOpen,
  variableData,
  variableDataLoading,
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [whatIfDetails, setWhatIfDetails] = useState({});

  const fetchWhatIfDetails = async () => {
    try {
      const {
        data: { job },
      } = await CompellonApi.fetchJobInfo({ job_id: selectedWhatIf?.id });
      setWhatIfDetails(getWhatIfDetails(job));
    } catch (error) {
      logger.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => variableData && fetchWhatIfDetails(), [variableData]);

  const getWhatIfDetails = ({
    job_settings: {
      adjustment: { column_adjustments },
    },
  }) => {
    const adjustments = getAdjustments(
      tempAdjustment ?? column_adjustments,
      variableData
    );
    const fromValue = roundNumbers(TARGET_RATES.final_target_rate * 100, 2);
    const toValue = roundNumbers(TARGET_RATES.initial_target_rate * 100, 2);
    return {
      adjustments,
      targetRate: {
        fromValue,
        toValue,
        change: roundNumbers(toValue - fromValue, 2),
      },
    };
  };

  return (
    <Modal
      isOpen={isWhatIfModalOpen}
      onClose={() => setIsWhatIfModalOpen(false)}
      size="md"
    >
      {isLoading || variableDataLoading ? (
        <div className="h-32">
          <PageLoader />
        </div>
      ) : (
        <Details whatIfDetails={whatIfDetails} metadata={selectedWhatIf} />
      )}
      <Modal.Footer />
    </Modal>
  );
};

export default View;
